import React from "react";

// import styles from "./Dashboard.module.css";
import { withRouter } from "react-router-dom";
// import LeftSideNav from "./LeftSideNav";
// import TradeHistory from "./TradeHistory";
import { isAuthenticated } from "../store/selectors/AuthSelectors";
import { connect } from "react-redux";
import { QueryClientProvider, QueryClient } from "react-query";
// import DashboardLayout from "../DashboardLayout"
import Header from "../Header/Header";
import HomePage from "./Homepage";
const queryClient = new QueryClient();


const Dashboard = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <Header />
      {/* <DashboardLayout> */}
        <div
          // className={`bg-gradient-to-b from-[#000000]/5 to-[#231c04] flex flex-col xl:min-h-screen w-full lg:items-center justify-center px-3 lg:px-0 w-full min-h-screen`}
          className={`bg-gradient-to-b from-[#000000]/5 to-[#000000] flex flex-col xl:min-h-screen w-full lg:items-center justify-center px-3 lg:px-0 w-full min-h-screen pb-[5rem] lg:pb-[1rem]`}
        >
          {/* <TradeHistory /> */}
          <HomePage />
        </div>
      {/* </DashboardLayout> */}
    </QueryClientProvider>
  );
};

const mapStateToProps = (state) => {
  return {
    isAuthenticated: isAuthenticated(state),
  };
};

export default withRouter(connect(mapStateToProps)(Dashboard));
